export enum Roles {
    ADMIN= "ROLE_ADMIN",
    USER="ROLE_USER"
}